import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';
import { HeaderSection } from '../HeaderSection';

export const ActionBarStyled = styled.div`
  padding-bottom: 3rem;
  top: 0;
  background-color: ${colors.neutral[100]};
`;

export const HeaderSectionStyled = styled(HeaderSection)`
  gap: 2rem;
  border-top: 1px solid ${colors.neutral[300]};

  /* Align buttons to the left when they don't fill the full width 
     to prevent large empty gaps between them */
  justify-content: flex-start;

  @media (width <= 1458px) {
    justify-content: center;
    gap: 1rem;
  }
`;
